import { CheckOutlined, CloseOutlined, InfoCircleFilled } from "@ant-design/icons";
import { Modal, Spin, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { isNullOrUndefined } from "../../common/utils";
import AuthZButton from "../AuthzButton";
import { PreviewModalComponent } from "../previewModalComponent";
import "./index.css";

export const AsyncActionButtonOrLink = (
  {
    buttonProps,
    modalProps,
    modalOkButtonProps,
    modalCancelButtonProps,
    type,
    linkText,
    tooltipText,
    displayModal = false,
    showLoadingOverlay = false
  }) => {
  const [confirmationProgress, setConfirmationProgress] = useState(false);
  const [buttonClickProgress, setButtonClickProgress] = useState(false);
  const [visible, setVisible] = useState(false);
  const modalRef = useRef();
  const showModal = async () => {
    if (!isNullOrUndefined(buttonProps?.onButtonClick)) {
      setButtonClickProgress(true);
      try {
        await buttonProps.onButtonClick();
        setButtonClickProgress(false);
        setVisible(true);
      } catch (err) {
        setButtonClickProgress(false);
      }
    } else {
      setVisible(true);
    }
  };

  useEffect(() => {
    if (displayModal)
      showModal().then()
  }, [displayModal])

  function okHandler() {
    setConfirmationProgress(true);
    modalOkButtonProps.okCallback().finally(() => {
      setConfirmationProgress(false);
      setVisible(false);
    });
  }

  function cancelHandler() {
    setVisible(false);
    if (!isNullOrUndefined(modalCancelButtonProps?.cancelCallBack)) {
      modalCancelButtonProps.cancelCallBack();
    }
  }

  function renderLink() {
    return (
      <Tooltip
        placement="top"
        title={tooltipText}
      >
        <a
          className="linkSpan"
          onClick={showModal}
        >
          {linkText}
        </a>
      </Tooltip>
    );
  }

  function renderButton() {
    return (
      <AuthZButton
        tooltipPlacement="top"
        tooltipTitle={tooltipText}
        icon={buttonProps.icon}
        onClick={showModal}
        buttonDisabled={buttonProps.disabled}
        authZButtonType={buttonProps.authZButtonType}
        buttonLoading={buttonClickProgress}
        ariaLabel={buttonProps.ariaLabel}
      >
        {buttonProps.text}
      </AuthZButton>
    );
  }

  function renderButtonOrLink() {
    return <>{type === "button" ? renderButton() : type === "link" ? renderLink() : null}</>;
  }

  function renderModal() {
    if (modalProps.modalType === "preview") {
      return (
        <PreviewModalComponent
          visible={visible}
          onOk={okHandler}
          onCancel={cancelHandler}
          tableProperties={{
            columns: modalProps.columns,
            dataSource: modalProps.dataSource,
            pagination: false,
            rowClassName: modalProps.rowClassName,
            loading: false,
          }}
          modalHeaderContent={{ title: modalProps.title, content: modalProps.content }}
          confirmLoading={confirmationProgress}
          okButtonProps={{
            onOk: okHandler,
            confirmLoading: confirmationProgress,
            text: modalOkButtonProps.okText,
            disabled: modalOkButtonProps.disabled,
          }}
        />
      );
    } else {
      return (
        <Modal
          title={modalProps.title}
          visible={visible}
          onOk={okHandler}
          confirmLoading={confirmationProgress}
          onCancel={cancelHandler}
          closable={false}
          maskClosable={false}
          width={500}
          okButtonProps={{ icon: <CheckOutlined/>, disabled: modalOkButtonProps.disabled }}
          cancelButtonProps={{ icon: <CloseOutlined/>, disabled: confirmationProgress }}
          okText={modalOkButtonProps.okText}
          cancelText="Cancel"
          className={modalProps.className}
        >
          <div className="modal-content-body">
            <div>
              <InfoCircleFilled/>
            </div>
            <div className="modal-content-body-text">{modalProps.content}</div>
          </div>
        </Modal>
      );
    }
  }

  function renderLoadingOverlay() {
    if (buttonClickProgress && showLoadingOverlay) {
      return (
        <div className={"loading-overlay"}>
          <div className={"black-overlay"} />
          <Spin
            className={"load-spinner"}
            size={"large"}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  return (
    <div ref={modalRef}>
      {renderButtonOrLink()}
      {renderModal()}
      {renderLoadingOverlay()}
    </div>
  );
};
